import { useState, useEffect } from 'react';

/**
 * Custom hook to detect if the current viewport is mobile
 * @param {number} breakpoint - Width in pixels below which is considered mobile (default: 768px)
 * @returns {boolean} - True if viewport is mobile size
 */
export const useMobileDetector = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth < breakpoint : false
  );
  
  useEffect(() => {
    if (typeof window === 'undefined') return;
    
    const handleResize = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };
    
    // Add event listener
    window.addEventListener('resize', handleResize);
    
    // Call handler right away so state gets updated with initial window size
    handleResize();
    
    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);
  
  return isMobile;
}; 